import { ValuationDataValues } from "../../views/PropertyDetails/PropertyDetailsEnums";

export const valuationDropDownValues = Object.values(ValuationDataValues).map(
  (item) => ({
    value: item,
    label: item
  })
);
